const AboutContent = () => {
  return (
    <div>
      <p>
        <span style={{ fontWeight: "bold" }}>
          Hope for Children Organization (HFC)
        </span>{" "}
        is an indigenous, non-political, non-faith-based local NGO, established
        in November 2000 G.C with the key objectives of sustainable and
        comprehensive community based care and support for children and families
        affected by HIV/AIDS. HFC is registered as an Ethiopian resident charity
        with registration No. 0016. The organization has been successfully
        undertaking HIV/AIDS prevention and control programs since establishment
        through raising funds from multiple source: international and local as
        well.
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>The organization</span> The
        organization has 20 years experience on OVC addressing their education,
        health and care and support aspects. In relation this, HFC has managed
        to reached about 27,000 OVC and more than 10,000 PLWHA through
        mobilizing 450 volunteer service providers. The major service includes
        provision of shelter and care through group homes, health care,
        psychosocial and educational support, provision of food and nutrition.
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>Hope for Children</span>{" "}
        organization have presence at Addis Ababa city administration since
        establishment. And, the organization has an experience almost throughout
        the country regional states. The head office is located around Menen
        area with its own office. Currently we have active projects in Addis
        Abeba City Administration, Oromia and Harari regional states.
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>HFC</span> is implemented
        Integrated Community Based HIV/AIDS Preventive, Care and Support Project
        cooperating with USAID/Ethiopia in 9 towns from October 2013- September
        2016. During the project period 9,000 people got different care and
        support benefits also 9,000 people were addressed by economic
        strengthening support with VSLA trainings and follow up.
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>The other area </span>
        of HFC's engagement focuses on the promotion of village saving and Loan
        (VSLA) as asset building potential for poor households in the target
        areas. The effort has enabled to reach about 22,000 and 12,000 poor
        families in Addis Ababa and Oromia through VSLA project respectively. We
        are extensive period of partners with Plan International Ethiopia
        implementing VSLA project in successful manner for 8 years since
        November 2007 GC – June 2015 GC.
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>
          As one of the national implementing partners,{" "}
        </span>
        HFC has implemented the SCRHA/PATH project which is Strengthening
        Communities Response to HIV/AIDS through promoting the major activities
        of the project that include community and home based palliative care,
        economic strengthening and CSO capacity building. Such effort has
        enabled HFC to reach capacity improvement needs of 34 CSOs in 47 towns
        of Oromia and Amhara regions through mobilizing and participating
        community based volunteers and 39 generalists while addressing 86,871
        PLHIV affected and infected individuals. The provision of technical and
        supervisory support has been undertaken through involving project
        advisory committee, town health office, HAPCO, women and children
        affairs offices in project areas.
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>HFC </span>
        is working Ethiopian Social Accountability Project (World Bank Project)
        since 2013 till now coordinating different implementing partners. As a
        lead organization we have been facilitating some western and southern
        part of the country as well as since 2016 we are working by facilitating
        the Eastern part of 13 targeted woredas. have an experience working with
        International as well as Local partners, some of them are: UNICEF,
        USAID, Plan International, US Embassy, Irish Embassy, Norway, Embassy,
        Sweden Embassy, Good Will Community Foundation, Global Fund for
        Children, Partner in the Horn of Africa (PIHA), Ananda Foundation,
        Botanga Foundation, Hope for Children USA, World Bank trough Management
        Agency, Direct Reach Ethiopia (DRE) . . .
        <br />
        <br />
        <span style={{ fontWeight: "bold" }}>Currently, </span>
        HFC provides holistic support to HIV-AIDS infected and affected
        children. The support includes addressing basic needs of the children,
        and adults’ provision of psychosocial service to OVCs and their families
        as needed. Besides this, HFC runs a number of preventive interventions
        that aims to mitigate the impact of HIV/AIDS in the community through
        strengthened educational support. These are through residential care of
        terminal HIV-AIDS clients, youth enrichment services; community
        mobilization and facilitation, strengthening community Responses to
        HIV/AIDS, sponsorship through distance adoption, girls’ empowerment and
        social accountability.
      </p>
    </div>
  );
};

export default AboutContent;
